export const CLASS_CREATE_ZOOM_PASSWORD_ERROR = 3018;
